(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frankos-cookies-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var triggers = document.querySelectorAll('.fcp .frankos-faq-trigger');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var panel = this.nextElementSibling;

      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var p = t.nextElementSibling;
        if (p) p.hidden = true;
      });

      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frankos-payment-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var triggers = document.querySelectorAll('.frankos-faq-trigger');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var panel = this.nextElementSibling;

      // sluit alle andere
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var p = t.nextElementSibling;
        if (p) p.hidden = true;
      });

      // toggle huidige
      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
